import {
  getGap,
  getPaddings,
  mergeCtaSettings,
  mergeTypographySettings,
} from "@/utils/theme-helper";
import CtaComponent from "./CtaComponent";
import TypographyComponent, {
  TypographyComponentProps,
} from "./TypographyComponent";
import { CMSData, CMSSection, CtaComponentProps } from "@/cms/models";
import ContactForm, { ContactFormProps } from "./forms/ContactForm";
import { ApplicationFraction } from "@/utils/gql/graphql";
import ImageComponent from "./ImageComponent";

export interface StackedContentComponentProps {
  gap: "xs" | "sm" | "md" | "lg" | "xl";
  items: any[];
  padding: string;
  cmsData: CMSData;
  justify: "start" | "center" | "end";
}

export const ContentComponents: { [key: string]: React.FC<any> } = {
  CtaComponent: CtaComponent,
  TypographyComponent: TypographyComponent,
  ImageComponent: ImageComponent,
  ContactForm: ContactForm,
};

export const GetContentComponent = (
  cmsData: CMSData,
  item: any,
  key: string,
  index: number,
  app: ApplicationFraction
) => {
  const Component = ContentComponents[item.type];
  const config = loadConfig(item, cmsData, app);
  return (
    <div
      key={key}
      className={`flex w-full justify-${item.justify ?? "center"}`}
    >
      <Component id={key} itemIndex={index} config={config} />
    </div>
  );
};

export const loadConfig = (
  item: {
    type: string;
    config: TypographyComponentProps | CtaComponentProps | ContactFormProps;
  },
  cmsData: CMSData,
  app: ApplicationFraction
): TypographyComponentProps | CtaComponentProps | any  => {
  switch (item.type) {
    case "CtaComponent":
      return mergeCtaSettings(item.config as CtaComponentProps, cmsData, {
        size: "sm",
      });
    case "ContactForm":
      const foo = { app: app, cmsData: cmsData };
      console.log("ContactForm", foo);
      return foo;
    default:
      return mergeTypographySettings(item.config, cmsData);
  }
};

const StackedContentComponent: React.FC<{
  config: StackedContentComponentProps;
  index: string;
  cmsData: CMSData;
  app: ApplicationFraction;
  cmsSection: CMSSection<any>;
}> = ({ config, index, cmsData, cmsSection, app }) => {
  return (
    <div
      style={{ backgroundColor: cmsSection.specifics.content?.bgColor }}
      className={`flex h-full flex-col w-full items-${cmsSection.specifics.items ?? "center"} justify-${cmsSection.specifics.justify ?? "center"} ${getPaddings(config.padding)} ${getGap(config.gap)}`}
    >
      {config.items.map((item, itemIndex) =>
        GetContentComponent(
          cmsData,
          item,
          `stacked-content-${index}-${itemIndex}`,
          itemIndex,
          app
        )
      )}
    </div>
  );
};

export default StackedContentComponent;
